import Vue from 'vue';
import { ApartmentDTO } from '../../../model/ApartmentDTO';
import { BlockDTO } from '../../../model/BlockDTO';
import { InstanceType } from '../../../enums/InstanceType';

export async function apartmentInfoData(context: Vue, block: BlockDTO) {
	const apartment = context.$store.pageData.apartment as ApartmentDTO;
	const hypoCalcInfo = await context.$apartmentService.fetchHypoCalcInfo(
		apartment.totalPriceWithVAT,
		new Date(apartment.completionDate || 0)
	);

	hypoCalcInfo.ownFundsPercent = 20

	const storageFacilityImages = await Promise.all(
		apartment.storageFacilities.map(sf =>
			context.$resourceService.fetchImages(block.id, 'storage-facility', {[InstanceType.StorageFacility]: sf.catalogNumber})
		)
	);

	const parkingPlaceImages = await Promise.all(
		apartment.parkingPlaces.map(pp =>
			context.$resourceService.fetchImages(block.id, 'parking-place', {[InstanceType.ParkingPlace]: pp.catalogNumber})
		)
	);

	return {
		hypoCalcInfo,
		storageFacilityImages,
		parkingPlaceImages
	};
}
